import { render, staticRenderFns } from "./CardMealActionSave.vue?vue&type=template&id=73e16d73&scoped=true"
import script from "./CardMealActionSave.vue?vue&type=script&lang=js"
export * from "./CardMealActionSave.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73e16d73",
  null
  
)

export default component.exports